import { Link } from "@mui/material";
import styled from "styled-components";
import theme from "../theme";

import "@fontsource/poppins/100.css";
import "@fontsource/poppins/100-italic.css";
import "@fontsource/poppins/200.css";
import "@fontsource/poppins/200-italic.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/300-italic.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/400-italic.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/500-italic.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/600-italic.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/700-italic.css";
import "@fontsource/poppins/800.css";
import "@fontsource/poppins/800-italic.css";
import "@fontsource/poppins/900.css";
import "@fontsource/poppins/900-italic.css";

const MuiLink = styled(Link)`

    &.MuiLink-root {
        font-family: 'Poppins';
        line-height: 1.1;
        color: ${theme.dirtyYellow} !important;
        text-decoration-color: ${theme.dirtyYellow} !important;
        cursor: pointer;
    }
`

const StyledLink = (props) => {
    return (
        <MuiLink color={'primary'} {...props} />
    )
}

export default StyledLink;